import { AgreementBox } from "~/v2/components/form/AgreementBox";
import { FixedBottomMenu } from "../FixedBottomMenu";
import { AgreementPreviewModal } from "./AgreementPreviewModal.connector";
import type { AgreementsState } from "./Agreements.connector";

interface Agreements
  extends Record<
    keyof AgreementsState,
    {
      isOpen: boolean;
      isAccepted: boolean;
      agreementId: string;
    }
  > {}

interface AgreementsPresProps {
  accountId: string;
  agreements: Agreements;
  onOpenAgreement: (agreement: keyof Agreements) => void;
  onCloseAgreement: (agreement: keyof Agreements) => void;
  onAgreeAgreement: (agreement: keyof Agreements) => void;
  onBackClicked: () => void;
  onContinueClicked: () => void;
  isContinueButtonDisabled: boolean;
  isAgreementMutating: boolean;
}

export const AgreementsPres = ({
  accountId,
  agreements,
  onOpenAgreement,
  onCloseAgreement,
  onAgreeAgreement,
  onBackClicked,
  onContinueClicked,
  isContinueButtonDisabled,
  isAgreementMutating,
}: AgreementsPresProps) => (
  <div className="flex flex-col gap-4">
    <AgreementBox
      isAccepted={agreements.ctaAgreement.isAccepted}
      label="CTA Agreement"
      onOpen={() => onOpenAgreement("ctaAgreement")}
    />
    <AgreementBox
      isAccepted={agreements.utpAgreement.isAccepted}
      label="UTP Plan Subscriber Agreement"
      onOpen={() => onOpenAgreement("utpAgreement")}
    />
    <AgreementBox
      isAccepted={agreements.opraAgreement.isAccepted}
      label="Options Price Reporting Authority Agreement"
      onOpen={() => onOpenAgreement("opraAgreement")}
    />

    <AgreementPreviewModal
      isOpen={agreements.ctaAgreement.isOpen}
      title="CTA Agreement"
      accountId={accountId}
      agreementId={agreements.ctaAgreement.agreementId}
      onCancel={() => onCloseAgreement("ctaAgreement")}
      onAgree={() => onAgreeAgreement("ctaAgreement")}
      hasAgreed={agreements.ctaAgreement.isAccepted}
      isSubmitting={isAgreementMutating}
    />
    <AgreementPreviewModal
      isOpen={agreements.utpAgreement.isOpen}
      title="UTP Plan Subscriber Agreement"
      accountId={accountId}
      agreementId={agreements.utpAgreement.agreementId}
      onCancel={() => onCloseAgreement("utpAgreement")}
      onAgree={() => onAgreeAgreement("utpAgreement")}
      hasAgreed={agreements.utpAgreement.isAccepted}
      isSubmitting={isAgreementMutating}
    />
    <AgreementPreviewModal
      isOpen={agreements.opraAgreement.isOpen}
      title="Options Price Reporting Authority Agreement"
      accountId={accountId}
      agreementId={agreements.opraAgreement.agreementId}
      onCancel={() => onCloseAgreement("opraAgreement")}
      onAgree={() => onAgreeAgreement("opraAgreement")}
      hasAgreed={agreements.opraAgreement.isAccepted}
      isSubmitting={isAgreementMutating}
    />

    <FixedBottomMenu
      className="mt-[50%]"
      back={{
        label: "Back",
        onClick: onBackClicked,
      }}
      next={{
        label: "Continue",
        disabled: isContinueButtonDisabled,
        onClick: onContinueClicked,
      }}
    />

    <p className="mt-8 text-gray-400 text-xs">
      Securities Brokerage services are provided by Alpaca Securities , member
      FINRA/SIPC, a wholly-owned subsidiary of AlpacaDB, Inc. Technology and
      services are offered by AlpacaDB, Inc.
      <br />
      Cryptocurrency services are made available by Alpaca Crypto LLC ("Alpaca
      Crypto"), a FinCEN registered money services business (NMLS # 2160858),
      and a wholly-owned subsidiary of AlpacaDB, Inc. Alpaca Crypto is not a
      member of SIPC or FINRA. Cryptocurrencies are not stocks and your
      cryptocurrency investments are not protected by either FDIC or SIPC.
      Please see the{" "}
      <a
        href="https://alpaca.markets/disclosures"
        target="_blank"
        className="text-gray-400 underline"
        rel="noopener"
      >
        Disclosure Library
      </a>{" "}
      for more information.
      <br />
      This is not an offer, solicitation of an offer, or advice to buy or sell
      securities or cryptocurrencies, or open a brokerage account or
      cryptocurrency account in any jurisdiction where Alpaca Securities, Alpaca
      Crypto, are not registered or licensed, as applicable.
    </p>
  </div>
);
